const topics = [
  { name: '热血漫画', heat: '98万+人气', icon: 'ri-fire-line' },
  { name: '恋爱漫画', heat: '86万+人气', icon: 'ri-heart-line' },
  { name: '悬疑漫画', heat: '72万+人气', icon: 'ri-search-eye-line' },
  { name: '奇幻漫画', heat: '68万+人气', icon: 'ri-magic-line' },
  { name: '搞笑漫画', heat: '65万+人气', icon: 'ri-emotion-laugh-line' },
  { name: '都市漫画', heat: '58万+人气', icon: 'ri-building-line' },
  { name: '校园漫画', heat: '52万+人气', icon: 'ri-school-line' },
  { name: '古风漫画', heat: '47万+人气', icon: 'ri-vip-crown-line' },
  { name: '科幻漫画', heat: '41万+人气', icon: 'ri-rocket-line' },
  { name: '惊悚漫画', heat: '36万+人气', icon: 'ri-ghost-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          热门话题标签
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-100 hover:bg-primary-50 rounded-xl p-4 md:p-5 transition-colors cursor-pointer border border-background-200/60 hover:border-primary-200"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${topic.icon} text-primary-500 text-lg`}></i>
              </div>
              <h3 className="font-medium text-foreground-900 text-sm md:text-base mb-1">{topic.name}</h3>
              <p className="text-xs text-foreground-500">{topic.heat}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}